import { makeAutoObservable } from 'mobx'
import { type PageLayoutStore } from 'shared/layout'

export class ReviewsPageStore {
  constructor(readonly pageLayoutStore: PageLayoutStore) {
    makeAutoObservable(this)
  }
}
